import { useEffect, useState } from "react";
import { Wheel } from "react-custom-roulette";
import confetti from "canvas-confetti";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import API_URL from "../../config";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { v4 as uuidv4 } from "uuid";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { BsCalendar2 } from "react-icons/bs";
import DatePicker from "react-datepicker";
import giftgif from "../../assets/gift.gif";
import rewardgif from "../../assets/confetti.gif";
import downarrow from "../../assets/down3.png";
import off1 from "../../assets/off10.png";
import off15 from "../../assets/off15.png";
import surprise from "../../assets/surprise.gif";
import coin from "../../assets/coin.png";
import consultation from "../../assets/consultation.png";
import oops from "../../assets/oops.png";

const data = [
  {
    option: "Free Consultation",
    image: {
      uri: consultation,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },

  {
    option: "Better Luck",
    image: {
      uri: oops,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },
  {
    option: "10% Off",
    image: {
      uri: off1,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },
  {
    option: "100 AED",
    image: {
      uri: coin,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },
  {
    option: "15% Off",
    image: {
      uri: off15,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },
  {
    option: "Surprise Box",
    image: {
      uri: surprise,
      style: {
        width: "30px",
        height: "30px",
        marginBottom: "5px",
        objectFit: "contain",
      },
    },
  },
];

function SpinWheel() {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [showWheel, setShowWheel] = useState(true);
  const [showConfetti, setShowConfetti] = useState(
    data[prizeNumber]?.option !== "Better Luck" ? true : false
  );
  const [showForm, setShowForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [useruuid, setUseruuid] = useState(null);
  const [isUnclaimedReward, setIsUnclaimedReward] = useState(false);
  const [showClaimedPopup, setShowClaimedPopup] = useState(false);
  const [claimedReward, setClaimedReward] = useState(null);

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    email: "",
    profession: "",
    interestin: "",
    appointmentDate: null,
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleNext = () => setStep((prev) => prev + 1);
  const handleBack = () => setStep((prev) => prev - 1);

  useEffect(() => {
    let existingUUID = localStorage.getItem("spin_uuid");
    if (!existingUUID) {
      existingUUID = uuidv4();
      localStorage.setItem("spin_uuid", existingUUID);
    }
    setUseruuid(existingUUID);

    const storedReward = JSON.parse(localStorage.getItem("spin_reward"));

    if (storedReward) {
      const now = new Date();
      const expiry = new Date(storedReward.timestamp);
      expiry.setDate(expiry.getDate() + 7);

      if (now < expiry) {
        if (storedReward.claimed) {
          setShowWheel(false);
          setClaimedReward(storedReward.rewards);
          setShowClaimedPopup(true);
        } else {
          setPrizeNumber(
            data.findIndex((item) => item.option === storedReward.rewards)
          );
          setShowWheel(false);
          setShowForm(true);
          setIsUnclaimedReward(true);
        }
      } else {
        localStorage.removeItem("spin_reward");
      }
    }
  }, [10000]);

  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * data.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
  };

  const handleStopSpinning = () => {
    setMustSpin(false);
    // runConfetti();

    const rewardData = {
      rewards: data[prizeNumber].option,
      timestamp: new Date().toISOString(),
      isClaimed: false,
    };
    localStorage.setItem("spin_reward", JSON.stringify(rewardData));

    setTimeout(() => {
      setShowWheel(false);
      setShowForm(true);
      setIsUnclaimedReward(false);
    }, 2000);
  };

  const runConfetti = () => {
    confetti({
      particleCount: 400,
      spread: 300,
      origin: { y: 0.6 },
      colors: ["#FFD700", "#FFA500", "#FFF8DC"], // gold, orange, and light gold
      zIndex: 9999,
    });
    setTimeout(() => {
      confetti({
        particleCount: 200,
        spread: 70,
        origin: { y: 0.6 },
        colors: ["#FFD700", "#FFA500", "#FFF8DC"],
        zIndex: 9999,
      });
    }, 400);
  };

  const closeAll = () => {
    setShowForm(false);
    setShowWheel(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const rewardData = JSON.parse(localStorage.getItem("spin_reward"));
    console.log("rewardData", rewardData);
    // const date = formData.appointmentDate;
    // const formattedDate = date
    //   ? `${String(date.getDate()).padStart(2, "0")}/${String(
    //       date.getMonth() + 1
    //     ).padStart(2, "0")}/${date.getFullYear()} ${
    //       date.getHours() % 12 || 12
    //     }:${String(date.getMinutes()).padStart(2, "0")} ${
    //       date.getHours() >= 12 ? "PM" : "AM"
    //     }`
    //   : "";

    const payload = {
      useruuid: useruuid,
      ...formData,

      rewards: rewardData?.rewards,
      submittedAt: rewardData?.timestamp,
      isClaimed: true,
    };

    console.log("Form Data", payload);

    try {
      const res = await axios.post(`${API_URL}/layout/send-mail`, payload);
      if (res.data.success) {
        setShowClaimedPopup(true);
        localStorage.setItem(
          "spin_reward",
          JSON.stringify({
            ...JSON.parse(localStorage.getItem("spin_reward")),
            claimed: true,
          })
        );
        closeAll();
      } else {
        toast.error("Something went wrong: " + res.data.error);
      }
    } catch (error) {
      toast.error("Oops! It seems required fields are missing.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const pointerStyle = {
    width: "90px",
    height: "90px",
    position: "absolute",
    right: window.innerWidth < 768 ? "3vw" : "0vw",
    marginTop: "10px",
    objectFit: "contain",
  };
  useEffect(() => {
    if (showForm) {
      runConfetti();
    }
  }, [showForm]);
  return (
    <>
      {showWheel && (
        <div className="spin-overlay">
          <IoMdClose className="spin-wheel-close-btn" onClick={closeAll} />
          <div className="spin-popup d-flex flex-column mt-5">
            <div
              style={{
                borderRadius: "50%",
                border: "3px solid #c69933",
                padding: "10px",
                background:
                  "radial-gradient(circle, rgba(219, 158, 14, 0.3) 0%, rgba(16, 15, 15, 0) 80%)",
                boxShadow: "0 0 120px rgba(209, 154, 25, 0.5)",
              }}
            >
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={data}
                onStopSpinning={handleStopSpinning}
                backgroundColors={["#fbf5e5", "#bdab7d"]}
                textColors={["black"]}
                outerBorderColor="#c69933"
                radiusLineColor="#c69933"
                fontSize={14}
                fontFamily="cursive"
                textDistance={80}
                perpendicularText={true}
                pointerProps={{
                  src: downarrow,
                  style: pointerStyle,
                }}
              />
            </div>

            <button
              className=" mt-4 px-4 py-2 rounded-pill fw-bold"
              style={{
                border: "1px solid #c69933",
                background: "transparent",
                backgroundColor: "#fbf5e5",
                fontFamily: "cursive",
              }}
              onClick={handleSpinClick}
              disabled={mustSpin}
            >
              {mustSpin ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "#c69933", marginRight: "10px" }}
                  ></span>
                  Spinning...
                </>
              ) : (
                "Spin to Win"
              )}
            </button>
          </div>
        </div>
      )}

      {showForm && data[prizeNumber]?.option !== "Better Luck" && (
        <motion.div
          className="spin-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="spin-popup-container">
            <IoMdClose className="spin-close-btn" onClick={closeAll} />
            <motion.div
              className="spin-popup-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", delay: 1 }}
              style={{
                border: "3px solid #c69933",
                boxShadow:
                  "0 0 5px rgba(198, 153, 51, 0.7), 0 0 30px rgba(198, 153, 51, 0.5)",
                position: "relative",
              }}
            >
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                <h4 className="congrats-title">
                  {isUnclaimedReward ? (
                    <>
                      <div className="d-flex justify-content-center align-items-center flex-column text-center">
                        <img
                          src={giftgif}
                          alt="Reward"
                          className="img-fluid rounded"
                          style={{ maxWidth: "20%", height: "auto" }}
                        />
                        <span> You have an unclaimed reward!</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <span>
                        <img
                          src={rewardgif}
                          alt="reward"
                          className="img-fluid rounded "
                          style={{ maxWidth: "15%", height: "auto" }}
                        />
                      </span>
                      <span
                        className="mt-4"
                        style={{
                          fontSize: "30px",
                        }}
                      >
                        {" "}
                        Congratulations!
                      </span>
                    </>
                  )}
                </h4>
                <div
                  className=" prize-display"
                  style={{
                    fontSize: "20px",
                  }}
                >
                  <span>You Won:</span>
                  <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full shadow-md">
                    {data[prizeNumber]?.option}
                  </span>
                </div>

                <p className="form-instruction">
                  {isUnclaimedReward
                    ? "Just complete the form to claim your pending reward!"
                    : "Complete your details to claim your  reward"}
                </p>
              </motion.div>

              <form onSubmit={handleFormSubmit}>
                {step === 1 && (
                  <motion.div
                    key="step1"
                    initial={{ x: -50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 50, opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control spin-input"
                        placeholder="First Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control spin-input"
                        placeholder="Last Name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <select
                        className="form-control spin-input"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                        style={{
                          paddingTop: "12px",
                          paddingBottom: "12px",
                          borderColor: "#c69933",
                        }}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="text-end">
                      <button
                        type="button"
                        className="px-3 py-1 rounded  text-white"
                        onClick={handleNext}
                        style={{
                          backgroundColor: "#bdaa7d",
                          border: "2px solid #c69933",
                        }}
                      >
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </motion.div>
                )}

                {step === 2 && (
                  <motion.div
                    key="step2"
                    initial={{ x: 50, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -50, opacity: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <div className="mb-3">
                      <PhoneInput
                        country={"ae"}
                        enableSearch
                        name="phone"
                        value={formData.phone}
                        onChange={(phone) =>
                          setFormData({ ...formData, phone })
                        }
                        inputStyle={{
                          width: "100%",
                          height: "50px",
                          paddingLeft: "60px",
                          borderRadius: "0.375rem",
                          border: "1px solid #c69933",
                        }}
                        containerStyle={{ width: "100%" }}
                        buttonStyle={{ border: "none" }}
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="email"
                        className="form-control spin-input"
                        placeholder="Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control spin-input"
                        placeholder="Profession"
                        name="profession"
                        value={formData.profession}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={handleBack}
                      >
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button
                        type="button"
                        className="px-3 py-1 rounded  text-white"
                        onClick={handleNext}
                        style={{
                          backgroundColor: "#bdaa7d",
                          border: "2px solid #c69933",
                        }}
                      >
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </motion.div>
                )}
                {step === 3 && (
                  <>
                    <div className="mb-4">
                      <select
                        className="form-control spin-input"
                        name="interestin"
                        value={formData.interestin}
                        onChange={handleChange}
                        required
                        style={{
                          paddingTop: "12px",
                          paddingBottom: "12px",
                          borderColor: "#c69933",
                        }}
                      >
                        <option value="">Select Interested service</option>
                        <option value="Aesthetics">Aesthetics</option>
                        <option value="Weightloss & Smilling">
                          Weightloss & Smilling
                        </option>
                        <option value="Dental Treatment">
                          Dental Treatment
                        </option>
                        <option value="Physiotherapy">Physiotherapy</option>
                        <option value="Laser Treatment">Laser Treatment</option>
                        <option value="IV Drips">IV Drips</option>
                        <option value="Urology">Urology</option>
                        <option value="Homecare">Homecare</option>
                        <option value="Lab Tests">Lab Tests</option>
                      </select>
                    </div>

                    <div className="mb-3 position-relative">
                      <BsCalendar2
                        className="position-absolute"
                        style={{
                          top: "50%",
                          left: "15px",
                          transform: "translateY(-50%)",
                          color: "#c69933",
                          zIndex: 10,
                        }}
                      />
                      <DatePicker
                        selected={formData.appointmentDate}
                        onChange={(date) =>
                          setFormData({ ...formData, appointmentDate: date })
                        }
                        minDate={new Date()}
                        showTimeSelect
                        dateFormat="Pp"
                        placeholderText="Select Date & Time"
                        className="form-control w-100 ps-5"
                        wrapperClassName="w-100"
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="px-3 py-1 rounded"
                        onClick={handleBack}
                      >
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="px-3 py-1 rounded text-white"
                        style={{
                          backgroundColor: isSubmitting ? "#ccc" : "#bdaa7d", // Optional: gray out when disabled
                          border: "2px solid #c69933",
                          minWidth: "190px", // Keeps button size consistent
                          cursor: isSubmitting ? "not-allowed" : "pointer", // Optional: show disabled cursor
                        }}
                      >
                        {isSubmitting
                          ? "Submitting..."
                          : " Claim your reward! "}
                      </button>
                    </div>
                  </>
                )}
              </form>
            </motion.div>
          </div>
        </motion.div>
      )}

      {showClaimedPopup && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ zIndex: 1050, backgroundColor: "rgba(0,0,0,0.3)" }}
        >
          <motion.div
            className="bg-white rounded-3 shadow-sm p-4 mx-3"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ type: "spring", damping: 15 }}
            style={{
              maxWidth: "450px",
              width: "100%",
              border: "3px solid #bdaa7d",
            }}
          >
            <div className="text-center px-2">
              <div className="d-flex justify-content-center">
                <img
                  src={giftgif}
                  alt="Reward"
                  className="img-fluid rounded"
                  style={{ maxWidth: "20%", height: "auto" }}
                />
              </div>

              <h5 className="fw-bold mb-3">Your Reward Is Ready!</h5>

              <div className="bg-light rounded-3 py-2 px-3 mb-3">
                <p
                  className="fw-bold mb-0"
                  style={{
                    color: "#c69933",
                  }}
                >
                  {claimedReward}
                </p>
              </div>

              <div className="alert alert-warning bg-warning bg-opacity-10 border-warning border-opacity-25 p-2 mb-3 text-start small">
                <div className="d-flex align-items-center">
                  <span className="me-2">⏳</span>
                  <div>
                    <strong>Pending Collection:</strong> Please visit our clinic
                    to collect your reward within
                    <span className="fw-bold"> 7 days</span> before it expires.
                  </div>
                </div>
              </div>
              <p className="text-muted mb-4">We look forward to seeing you!</p>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className=" px-5  rounded-pill fw-bold text-white mt-2"
                onClick={() => setShowClaimedPopup(false)}
                style={{
                  border: "2px solid #c69933",
                  backgroundColor: "#bdaa7d",
                }}
              >
                I Understand
              </motion.button>
            </div>
          </motion.div>
        </div>
      )}
      <style>{`
    .calendar-icon {
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      color: #c69933;
      font-size: 1.2rem;
      z-index: 2;
      pointer-events: none;
    }

    .datepicker-input {
      height: 45px;
      font-size: 1rem;
      border: 1px solid #c69933;
      border-radius: 0.375rem;
      white-space: nowrap; /* Prevents wrapping */
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media (max-width: 576px) {
      .datepicker-input {
        font-size: 0.9rem;
        padding-left: 2.2rem;
        height: 42px;
      }

      .calendar-icon {
        font-size: 1rem;
        left: 10px;
      }
    }
  `}</style>
    </>
  );
}

export default SpinWheel;
